import { Currency } from '@src/@types/currency';
import { isKZPage } from '@src/utils/routing';
import { CurrencySymbol } from 'shared/config/internalization';

export const getSymbolByCode = (code: Currency = Currency.RUB): string => CurrencySymbol[code];

export const getCurrency = (path: string) => (isKZPage(path) ? Currency.KZT : Currency.RUB);
export const getCurrencySymbol = (path: string) => (isKZPage(path) ? CurrencySymbol.KZT : CurrencySymbol.RUB);
